import { StyleSheet } from 'react-native';

import { C } from '../../common';

const { CONTENT_MAX_WIDTH, PAGE_OFFSET } = C;

export default StyleSheet.create({
  container: {
    zIndex: 3,
  },

  viewportContent: {
    alignSelf: 'center',
    maxWidth: CONTENT_MAX_WIDTH,
    padding: 0,
  },

  content: {
    paddingVertical: PAGE_OFFSET,
    paddingHorizontal: PAGE_OFFSET,
  },

  location: {
    marginTop: PAGE_OFFSET,
  },

  button: {
    position: 'absolute',
    right: 0,
    top: 0,
    zIndex: 1,
  },
  buttonTopMoved: {
    position: 'absolute',
    right: 0,
    top: '60px',
    zIndex: 1,
  },
});
